<template>
<div class="group-invite">
    <loading v-if="loading"></loading>
    <select v-if="!loading && groups.length" v-model="selectedGroup" class="form-control">
        <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
    </select>
    <template v-if="!loading && !groups.length">{{ t.no_groups }}</template>
</div>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Loading from 'Site/component/Loading.vue';
import { mapActions } from 'vuex';

export default {
    name: 'GroupInvite',
    components: {
        Loading
    },
    data() {
        return {
            groups: [],
            loading: false,
            selectedGroup: null
        };
    },
    methods: {
        ...mapActions(['notify']),
        invite() {
            if (this.selectedGroup) {
                this.loading = true;
                ajax.create('groupInvite', {
                    username: this.invitee,
                    group: this.selectedGroup
                }).then((response) => {
                    this.notify({ msg: response.message });
                    this.$parent.$emit('hideModal');
                    this.loading = false;
                }).catch(({ response }) => {
                    response.then((error) => {
                        this.notify({ type: 'error', msg: error.message });
                        this.loading = false;
                    });
                });
            }
        },
        load() {
            if (this.groups.length) {
                return;
            }
            this.loading = true;

            ajax.get('group').then((response) => {
                this.loading = false;
                this.groups = this.groups.concat(response.items);
                if (this.groups.length) {
                    this.selectedGroup = this.groups[0].id;
                }
            });
        }
    },
    mounted() {
        this.$on('show', this.load);
        this.$on('submit', this.invite);
    },
    props: {
        invitee: {
            type: Number,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>

<style lang="scss">
@import "~Site/scss/variables";
.group-invite {
    .group-small {
        position: relative;
    }
    .fa-stack {
        position: absolute;
        right: 5px;
        top: 5px;
    }
    .fa-circle {
        color: $siteColor;
    }
}
</style>
